import { __rest, __assign } from 'tslib';
import clsx from 'clsx';
import React from 'react';

var BreadCrumbItem = function (_a) {
    var children = _a.children, _b = _a.current, current = _b === void 0 ? false : _b, aProps = __rest(_a, ["children", "current"]);
    var attr = {};
    if (current) {
        attr['aria-current'] = 'page';
    }
    return (React.createElement("div", __assign({ className: 'c-breadcrumb__item' }, attr),
        React.createElement("a", __assign({}, aProps), children)));
};
var BreadCrumbs = function (_a) {
    var dark = _a.dark, children = _a.children, className = _a.className, navProps = __rest(_a, ["dark", "children", "className"]);
    return (React.createElement("nav", __assign({}, navProps, { className: clsx(className, {
            'c-breadcrumb': true,
            'c-breadcrumb--theme-dark': dark
        }), "aria-label": 'breadcrumb' }), children));
};

export { BreadCrumbItem, BreadCrumbs };
//# sourceMappingURL=index.js.map
